export const gitVersion = {
  "tag": "v6.1.7",
  "commit": "641df08fcf07fd988ba608d7cbbec1aa159b4f6a",
  "branch": "main"
}